import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import SimpleTable from '../../components/SimpleTable';
import { Button, Typography } from '@mui/material';
import constants from '../../utilities/constants';
import AddServiceOrderDialog from '../../components/AddServiceOrderDialog';

export default function Services(props) {
  let { orders = [], filter = () => true, stockNumber, thumbnail = null, car = {} } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  let rows = orders.filter(filter);
  console.log(car)

  const summary = [
    {label: 'Revenue', value: rows.reduce((a,c) => a + c.revenue, 0), format:"usd"},
    // {label: 'Cost', value: rows.reduce((a,c) => a + c.cost, 0), format:"usd"},
    // {label: 'Profit', value: rows.reduce((a,c) => a + (c.revenue - c.cost), 0), format:"usd"},
  ];

  const tableData = {
    rows,
    summary,
    headers: [
      {key:'number', label:'Number'},
      {key:'date', label:'Date'},
      {key:'stock', label:'Service Order'}, 
      {key:'status', label:'Status'}, 
      // {key:'cost', label:'Cost', format:"usd"}, 
      {key:'revenue', label:'Revenue', format:"usd"}, 
    ],
    title: '', 
  };
  const active_orders = rows.filter(row => !["payment", "complete"].includes(row.status));
  const serviceEligible = constants.isCarServiceEligible(car?.status);


  const makeService2 = async (params = {}) => {
    setDialogOpen(true);
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <SimpleTable {...tableData}/>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        <Button variant="contained" color="primary" onClick={makeService2} disabled={!serviceEligible}>
          {/* {active_orders.length > 0 ? "Open active SO" : "Create Service Order"} */}
          Create Service Order
        </Button>
        {!serviceEligible && (
          <Typography variant="caption" color="text.secondary" align="center">
            A service order can't be created for a car with status "{car?.status}".
          </Typography>
        )}
      </Grid>
      <AddServiceOrderDialog 
        open={dialogOpen} 
        onClose={handleDialogClose}
        initialCar={car ? {
          objectID: car.id,
          stock: stockNumber,
          year: car.year,
          make: car.make,
          model: car.model,
          trim: car.trim,
          thumbnail: thumbnail,
          status: car.status
        } : null}
      />
    </Grid>
  );
}
